import React from 'react';
import cx from 'classnames';
import { ContentfulImg } from 'ha/modules/Contentful/components/ContentfulImg';

const MarkdownImage = ({ title, src, className, ...props }) => (
  <span className="display-block m-y-0_7">
    <ContentfulImg
      {...props}
      className={cx('img-contain-container', className)}
      src={src}
    />
    <span className="text-muted weight-normal">{title}</span>
  </span>
);

export { MarkdownImage };
